import { TextField } from "@funcional/react-ui";
import { Grid } from "@material-ui/core";
import { useEffect, useState } from "react";
import { DeepMap, FieldError, FieldValues } from "react-hook-form";

function actionType(readonly: boolean) {
    return {
        disabled: readonly ? true : false,
        cursor: readonly ? "not-allowed" : "default"
    }
}

export function TextInput({
    label, 
    item, 
    readonly, 
    control, 
    defaultData, 
    errors,
    register,
    index,
    helperText,
    watchValue,
}: {
    label?: string,
    item: string,
    readonly: boolean,
    control: any,
    defaultData: any,
    errors: DeepMap<FieldValues, FieldError>,
    onChange?: any,
    register?: any,
    index?: number,
    helperText?: string,
    watchValue?: any,
}) {
    let isQuinzenal = false;
    const defaultValueQuinzenal = '1 - 15 e 16 - último dia do mês';
    const [rerender, setRerender] = useState(false);

    useEffect(() => {
        setRerender(!rerender);
    }, [watchValue?.closureType]);
    
    if ((defaultData.closureType === "FORTWEEKLY") || (watchValue?.closureType === "FORTWEEKLY")) {
        isQuinzenal = true;
    };
    if (watchValue?.closureType && watchValue?.closureType !== "FORTWEEKLY") {
        isQuinzenal = false;
    };
    
    return (
        <Grid item xs={6} md={6} style={{marginTop: "0px"}}>
            <TextField
                key={index}
                disabled = {readonly || isQuinzenal}
                helperText={helperText}
                required
                control={control}
                value={isQuinzenal ? defaultValueQuinzenal : null}
                defaultValue={defaultData[item]}
                errorMessage={errors ? errors[item]?.message : null} 
                type="string"
                name={item}
                placeholder={isQuinzenal ? defaultValueQuinzenal : label}
                style={{width: "300px", cursor: actionType(readonly || isQuinzenal).cursor}}
                {...register ? {...register(
                    `exceptions.${index}.closingDay` as "exceptions.0.closingDay"
                )} : {}}
            />
        </Grid>
    )
}